module.exports = __webpack_public_path__ + "2acb60f2/img/link-icon.fa09ed66.svg";